import BaseComponent from '../../../base/base_component';
import {ANALYTICS} from '../navbar_const';

let sessionIdHtml = require('../view/session-id.html');

export default class GameSessionIdNavbarPart extends BaseComponent {
    static CLASS = 'GameSessionIdNavbarPart';

    init(params) {
        super.init(params);
        this._analyticsTrigger = params.analyticsTrigger;
        //this.getEl().style.display = 'block';
        this.getEl().onclick = () => {
            this._analyticsTrigger.send(ANALYTICS.ACTION.SESSION_ID);
        }
    }

    setGameSessionId(sessionId) {
        this.setInnerHtml(this.bake(sessionIdHtml, {sessionID: sessionId}));
    }
}